import { FormattedMessage as FM } from "react-intl";

import { CheckOnlyIcon } from "components/Icons";
import ColForm from "componentsv2/form/ColForm";
import { theme } from "theme/theme";
import { cn } from "tools/ui";

const styleBase =
  "h-5 w-5 ml-2 cursor-pointer peer appearance-none rounded-md border border-neutral-400 bg-white checked:border-teal-600 checked:bg-teal-400";

const styleLabel_ = "flex mt-9 pl-1";

function CheckboxField(props) {
  const {
    name,
    readOnly,
    label,
    data,
    required,
    onChange,
    style,
    styleLabel,
    colSpan,
    model,
  } = props;

  function handleCheck() {
    if (readOnly) {
      return;
    }

    data.value = !data.value;
    if (onChange) {
      onChange(name, data.value);
    }
  }

  return (
    <ColForm
      label={label}
      name={name}
      required={required}
      colSpan={colSpan}
      model={model}
    >
      <label key={name} className={cn(styleLabel_, styleLabel)}>
        {data.value && (
          <CheckOnlyIcon
            className={cn(
              "cursor-pointer absolute ml-3 text-white fill-current w-3 h-3 mt-1",
            )}
          />
        )}
        <input
          id={name}
          type="checkbox"
          name={name}
          onChange={handleCheck}
          readOnly={readOnly}
          disabled={readOnly}
          checked={data.value ?? false}
          className={cn(styleBase, style, styleLabel)}
        />
        <p className={cn("ml-3 text-sm", theme.textColor)}>
          <FM id={label} key={name} />
        </p>
      </label>
    </ColForm>
  );
}

export default CheckboxField;
